import React from "react";
import {
  Users,
  HousePlus,
  Stethoscope,
  Baby,
  HeartPulse,
  Clock,
  Home,
  HandHeart,
  HeartHandshake,
  ArrowUpRight,
} from "lucide-react";
import { services } from "../mock";

const icons = {
  Users,
  HousePlus,
  Stethoscope,
  Baby,
  HeartPulse,
  Clock,
  Home,
  HandHeart,
  HeartHandshake,
};

const Services = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 78, behavior: "smooth" });
  };

  return (
    <section id="services" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center reveal">
          <span className="eyebrow text-[#e07c24]">Our Services</span>
          <h2 className="font-display font-bold text-[#0e2a63] text-[34px] sm:text-[46px] mt-4">
            Some of Our Most Popular Services
          </h2>
          <p className="text-slate-500 max-w-2xl mx-auto mt-4 text-[17px]">
            We customize care plans that provide the right mix of services to
            preserve your loved ones&rsquo; independence and comfort.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-7 mt-14">
          {services.map((s, i) => {
            const Icon = icons[s.icon] || Users;
            const grad = s.color === "purple" ? "grad-purple" : "grad-blue";
            return (
              <div
                key={s.title}
                className={`service-card reveal reveal-delay-${(i % 3) + 1} bg-white rounded-2xl overflow-hidden shadow-lg border border-slate-100`}
              >
                <div className="relative h-56 overflow-hidden">
                  <img src={s.image} alt={s.title} className="service-img w-full h-full object-cover" />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(14,42,99,0.55), transparent 55%)" }} />
                  <div
                    className={`${grad} absolute bottom-0 left-0 right-0 flex items-center gap-3 px-5 py-3`}
                  >
                    <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center text-white">
                      <Icon size={20} />
                    </span>
                    <h3 className="text-white font-bold text-[17px] leading-tight">{s.title}</h3>
                  </div>
                </div>
                <div className="p-6">
                  <p className="text-slate-600 text-[15px] leading-relaxed min-h-[96px]">{s.desc}</p>
                  <button
                    onClick={() => scrollTo("contact")}
                    className="mt-2 inline-flex items-center gap-1.5 font-semibold text-[#e07c24] hover:gap-3 transition-all text-sm"
                  >
                    Learn More <ArrowUpRight size={17} />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
